import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48ff4600"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info" }

import loc from '@/locales';
import { State } from '@/timer';
import { computed } from 'vue';
import CircleBar from './CircleBar.vue';
import TipComponent from './TipComponent.vue';


interface Props{
  seconds: number
  value: number
  isBreakTime: boolean
  state: State
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    seconds: null,
    value: null,
    isBreakTime: { type: Boolean },
    state: null
  },
  setup(__props: any) {

const props = __props as {
  seconds: number
  value: number
  isBreakTime: boolean
  state: State
};



const title = computed(() => {
  if(props.state === 'running') {
    if(props.isBreakTime) {
      return loc.locales.value.titles.break
    } else return loc.locales.value.titles.focus
  } else if(props.state === 'suspended') {
    return loc.locales.value.titles.pause
  } else if(props.state === 'prepare') return loc.locales.value.titles.prepare
  else return loc.locales.value.titles.common
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", {showGif: !__props.isBreakTime && __props.state === 'running'}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", null, [
        _createElementVNode("h2", null, _toDisplayString(_unref(title)), 1),
        (__props.state !== 'running' && __props.state !== 'prepare')
          ? (_openBlock(), _createBlock(TipComponent, {
              key: props.state
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(CircleBar, {
        radius: 20,
        thin: 10,
        size: 100,
        fontSize: 24,
        seconds: __props.seconds,
        value: __props.value
      }, null, 8, ["seconds", "value"])
    ])
  ], 2))
}
}

})